import { MEDEAU_LOGIN } from '../pages/offline/constants/HomeConstants'

const getLogin = () => {
    return localStorage.getItem(MEDEAU_LOGIN)
}

export { getLogin }
